import { ARCurrency } from 'src/utils/currency';
import { formatMoney } from 'src/utils/global';
import { ITransactionsSummary } from 'src/interfaces/transactions';

export const EM_DASH = '—';

export interface KpiValues {
  totalPayments: string;
  tpvTotal: string;
  averageTicket: string;
  approvalRate: string;
  canceledRate: string;
}

const formatPercent = (rate?: number | null): string => {
  if (rate === null || rate === undefined || Number.isNaN(rate)) return EM_DASH;
  return `${(rate * 100).toLocaleString('es-AR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};

const formatCount = (value?: number | null): string =>
  value === null || value === undefined ? EM_DASH : ARCurrency.format(value);

const formatMoneyOrDash = (value?: number | null): string =>
  value === null || value === undefined ? EM_DASH : formatMoney(value);

/**
 * Construye los valores a mostrar de los 5 KPIs.
 * - Total de pagos: del summary o, como fallback (mientras /summary no exista en backend),
 *   del total_results del listado.
 * - Ticket promedio: em dash cuando Total de pagos = 0 (evita división por cero).
 * - Tasa de aprobación y % Canceladas: rates (0-1) provistas por backend, formateadas a %.
 */
export const buildKpis = (
  summary: ITransactionsSummary | undefined,
  totalFromList: number | undefined,
  hasError: boolean
): KpiValues => {
  if (hasError && !summary) {
    return {
      totalPayments: formatCount(totalFromList ?? null),
      tpvTotal: EM_DASH,
      averageTicket: EM_DASH,
      approvalRate: EM_DASH,
      canceledRate: EM_DASH
    };
  }

  const totalPayments = summary?.total_payments ?? totalFromList ?? null;
  const tpv = summary?.tpv_total ?? null;
  const averageTicket =
    totalPayments && totalPayments > 0
      ? summary?.average_ticket ?? (tpv !== null ? tpv / totalPayments : null)
      : null;

  return {
    totalPayments: formatCount(totalPayments),
    tpvTotal: formatMoneyOrDash(tpv),
    averageTicket: formatMoneyOrDash(averageTicket),
    approvalRate: formatPercent(summary?.approval_rate),
    canceledRate: formatPercent(summary?.canceled_rate)
  };
};
